// Configuration for absolutevision.in (AbsoluteVision)
const config = {
  cognito: {
    authority: process.env.REACT_APP_COGNITO_AUTHORITY || "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_NyOuCyVhQ",
    client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || "4qb1cgbcdltmp69itfn3e5irs2",
    redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI || "https://absolutevision.in",
    cognito_domain: process.env.REACT_APP_COGNITO_DOMAIN || "https://ap-south-1nyoucyvhq.auth.ap-south-1.amazoncognito.com",
  },

  api: {
    // Backend for authentication
    auth_backend: process.env.REACT_APP_AUTH_BACKEND || "https://api.school-erp.local:8081",
    
    // School ERP dashboard (after successful login)
    dashboard_url: process.env.REACT_APP_DASHBOARD_URL || "https://app.school-erp.local:3000/dashboard"
  },

  // Environment
  environment: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development'
};

export default config;
